export const WORKSHEET_NAMESPACE_PREFIX = 'ns-';
export const RECIPE_NAMESPACE_PREFIX = 'ns-recipe-';

export function createWorksheetNamespace(id: string): string {
  return `${WORKSHEET_NAMESPACE_PREFIX}${id}`;
}

export function createProcedureNamespace(id: string): string {
  return `${RECIPE_NAMESPACE_PREFIX}${id}`;
}

export function getWorksheetIdFromNamespace(tableNamespace: string | undefined): string | null {
  if (!tableNamespace) {
    return null;
  }
  // Step config namespaces
  if (tableNamespace.startsWith(RECIPE_NAMESPACE_PREFIX)) {
    return tableNamespace.slice(RECIPE_NAMESPACE_PREFIX.length);
  }
  // Step execution namespaces
  if (tableNamespace.startsWith(WORKSHEET_NAMESPACE_PREFIX)) {
    return tableNamespace.slice(WORKSHEET_NAMESPACE_PREFIX.length);
  }
  return null;
}
